import serialize from 'form-serialize';
import States from '../collection/statescollection';
import Countries from '../collection/countriescollection';


const AddressForm = Backbone.View.extend({
  tagName: 'form',
  className: 'address-form',
  events: {
    'click .toggle-form': 'toggleForm',
    'blur input.required, select.required': 'validateInput',
    'submit #edit-address-form': 'validate',
    'change select#countryID': 'countrySelect'
  },
  template: JST.addressForm,
  initialize({ model }) {
    this.states = new States();
    this.countries = new Countries();
    this.model = model;

    this.listenTo(this.model, 'change', this.render);
  },
  render() {
    const html = this.template({
      ...this.model.defaults.userAddress,
      ...this.model.get('userAddress'),
      states: this.states,
      countries: this.countries
    });

    this.$el.html(html);

    return this.el;
  },
  getValue() {
    const data = serialize(this.el, { hash: true });
    data.countryID = parseInt(data.countryID, 10);
    data.stateID = _.has(data, 'stateID') ? parseInt(data.stateID, 10) : 0;

    // if the address is empty return and empty object
    if (data.countryID === 0 && data.stateID === 0 && !data.city) {
      return {
        'userAddress': null
      };
    }

    return { 'userAddress': data };
  },
  validateInput(e) {
    const $this = _.has(e, 'target') ? $(e.target) : e;
    const $valMsg = this.$(`span[data-valmsg-for="${$this.attr('name')}"]`);
    let isValid = true;
    if ($this.val().length < 1 || parseInt($this.val(), 10) === 0) {
      $valMsg.html($this.data('val-required'));
      isValid = false;
    } else {
      $valMsg.html('');
    }
    $this.toggleClass('error', !isValid);
    return isValid;
  },
  validate() {
    let validForm = true;

    // if all three address properties are empty pass the validation
    if (parseInt(this.$('#countryID').val(), 10) === 0
      && this.$('#address1').val() === ''
      && this.$('#city').val() === '') {
      return validForm;
    }

    this.$('input.required, select.required').each((i, el) => {
      if (validForm) {
        validForm = this.validateInput($(el));
      }
    });

    return validForm;
  },
  countrySelect(e) {
    const id = parseInt($(e.target).val(), 10);
    const userAddress = { ...this.model.get('userAddress'), countryID: id };
    this.model.set('userAddress', userAddress);
  }
});

export default AddressForm;
